// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"19b55024","455":"734b8c37","479":"88e3b9b9","492":"ebdc6972","638":"cca1ad6e","962":"1ac68cc5","977":"685612f4"}[chunkId] + ".chunk.js";
};